import dataStore from "../Store/dataStore";

//useAuth.getSetting is an exact dictionary lookup, but the API matches config names
//case-insensitively (GetConfigValue lowercases both sides). This keeps the two in step,
//so a setting stored as e.g. PDATallyGs1BarcodeRules is still found.
export const getSettingIgnoreCase = (settingName: string): string | undefined => {
  const settings = dataStore.userInfo?.settings;
  if (!settings || !settingName) {
    return undefined;
  }
  const exact = settings[settingName];
  if (exact !== undefined) {
    return exact;
  }
  const wanted = settingName.toLowerCase();
  const key = Object.keys(settings).find((k) => k.toLowerCase() === wanted);
  return key !== undefined ? settings[key] : undefined;
};
